// export DSFSCSurveyProjectList from './surveyProject'
export const DSFSCSurveyProjectList = Vue.defineLazyComponent(()=>require('./surveyProject.vue'));